
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inscription/prof",
      function () {
        return require("private-next-pages/inscription/prof.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inscription/prof"])
      });
    }
  